export const summaryBatchSearchSchema = Object.freeze
(
    {
        baseFields: [
            {
                id: "batchId",
                title: "Batch Id",
                uiType: "text",
                searchParam: "BatchId",
                components: []
            },
            {
                id: "customerBatchId",
                title: "Order",
                uiType: "text",
                searchParam: "CustomerBatchId",
                components: []
            },
            {
                id: "retailerBatchId",
                title:  "PO",
                uiType: "text",
                searchParam: "retailerBatchId",
                components: []
            },
            {
                id: "eventStartDate",
                title: "Date Range",
                uiType: "custom",
                searchParam: "EventStartDate",
                components: []
            },
            {
                id: "eventEndDate",
                title: "Date Range",
                uiType: "custom",
                searchParam: "EventEndDate",
                components: []
            },
            {
                id: "status",
                title: "Status",
                uiType: "optionList",
                options: [
                    {label: "All", value: "ALL"},
                    {label: "Ok", value: "ok"},
                    {label: "Error", value: "error"}
                ],
                searchParam: "status",
                components: []
            }
        ],
        searchFields: [
            {
                id: "itemId",
                title: "Item Id",
                placeholder: "itemId",
                uiType: "text",
                searchParam: "growerid",
                path: "Items.ItemId",
                components: []
            },
            {
                id: "gtin",
                title: "GTIN",
                placeholder: "gtin",
                uiType: "text",
                searchParam: "gtin",
                path: "Items.Item.Gtin",
                components: []
            },
            {
                id: "batchNbr",
                title: "Batch Nbr",
                placeholder: "batchnbr",
                uiType: "text",
                searchParam: "batchNbr",
                path: "Items.LotQtys.BatchNbr",
                components: []
            },
            {
                id: "lotId",
                title: "Lot Id",
                placeholder: "lotid",
                uiType: "text",
                searchParam: "lotId",
                path: "Items.LotQtys.HarvestLot.LotId",
                components: []
            },
            {
                id: "growerId",
                title: "Grower Id",
                placeholder: "growerId",
                uiType: "text",
                searchParam: "growerId",
                path: "Items.LotQtys.HarvestLot.GrowerId",
                components: []
            },
            {
                id: "blockId",
                title: "Block Id",
                placeholder: "blockid",
                uiType: "text",
                searchParam: "blockid",
                path: "Item.LotQtys.HarvestLot.BlockId",
                components: []
            }
        ]
    }

)